import { Module } from '@nestjs/common';
import { AuthService } from './auth.service';
import { AuthController } from './auth.controller';
import { PassportModule} from '../passport/passport.module';
import {JwtModule} from '@nestjs/jwt';
import {JwtStrategy} from './jwt.strategy'
import {UserModule} from '../user/user.module';
import { SessionSerializer } from './session.serializer';
import { TypeOrmModule } from '@nestjs/typeorm';
import { UserEntity } from '../user/user.entity';

require('dotenv').config();
@Module({
  imports:[ 
    // TypeOrmModule.forFeature([UserEntity]),
    UserModule,
    JwtModule.register({
      // global: true,
      secret: 'ramakrishna',
      signOptions: { expiresIn: '86400000' },
    }),
  ],
  providers: [AuthService,JwtStrategy,SessionSerializer],
  controllers: [AuthController],
  exports:[AuthService]
})
export class AuthModule {}
